import {InjectionToken, Provider} from '@angular/core';

export const TISA_PREMIUM_OVERLAY_COMPONENT_LABEL = new InjectionToken(
  'Provides a title for premium content overlay.',
);

export const TISA_PREMIUM_OVERLAY_COMPONENT_ACTION_LABEL = new InjectionToken(
  'Provides an action label for premium content overlay.',
);

export const TISA_PREMIUM_OVERLAY_COMPONENT_ACTION_GOAL_LABEL = new InjectionToken(
  'Provides an action label goal for premium content overlay.',
);

export const TISA_DEFAULT_PREMIUM_OVERLAY_PROVIDERS: Provider[] = [
  {
    provide: TISA_PREMIUM_OVERLAY_COMPONENT_LABEL,
    useValue: 'Premium content',
  },
  {
    provide: TISA_PREMIUM_OVERLAY_COMPONENT_ACTION_LABEL,
    useValue: 'Sign up',
  },
  {
    provide: TISA_PREMIUM_OVERLAY_COMPONENT_ACTION_GOAL_LABEL,
    useValue: 'to get access',
  },
];
